module.exports = __webpack_public_path__ + "img/28_ancillary.61f98222.jpg";